
import {bus} from "../autoload/_vue";

export default {
    props   : ['tabs'],
    data() {
        return {
            bus,
            tabsFlat : {}
        }
    },
    created() {
        this.addIsActive()
        this.flattenTabs();
    },
    mounted() {
        const slugs = Object.keys(this.tabsFlat);
        const slug  = slugs.indexOf(location.hash.substr(2)) !== -1 ? location.hash.substr(2) : slugs.shift();
        this.loadContent(slug);
    },
    methods : {
        addIsActive(tabs) {
            tabs = tabs || this.tabs;
            for (let slug in tabs) {
                tabs[slug].isActive = false;
                tabs[slug].children && this.addIsActive(tabs[slug].children);
            }
        },

        flattenTabs() {
            let tabsFlat = {}, tabs = this.tabs;
            Object.keys(tabs).forEach(key => {
                tabsFlat[key] = Object.assign({}, tabs[key]);

                if (tabs[key].children) {
                    delete tabsFlat[key].children;
                    tabsFlat = Object.assign({}, tabsFlat, tabs[key].children);
                }
            });

            this.tabsFlat = tabsFlat;
        },

        isActiveClass(slug) {
            return this.tabsFlat[slug] && this.tabsFlat[slug].isActive ? ' active' : '';
        },
        hasActiveChildClass(slug) {
            const children = (this.tabs[slug] && this.tabs[slug].children) || false;

            return children && Object.keys(children).filter(item => this.tabsFlat[item].isActive).length > 0 ? ' has-active-child' : '';
        },
        loadContent(slug) {
            Object.keys(this.tabsFlat).map(slug => this.tabsFlat[slug]["isActive"] = false);
            this.tabsFlat[slug]["isActive"] = true;
            console.log(this.tabsFlat[slug]);
            const title   = this.tabsFlat[slug] && this.tabsFlat[slug].page_title;
            const content = this.tabsFlat[slug] && this.tabsFlat[slug].content;
            bus.$emit('update-content', {title, content});
        }
    }
}
